// Import Swiper and its styles
import Swiper from "swiper/swiper.esm.js";

export default class CarouselNews {
  constructor() {
    this.carouselWrapper = document.querySelectorAll(".jsCarouselNewsWrapper");

    if (this.carouselWrapper) this.init();
  }

  setCarousel(i) {
    this.carousel = i.querySelectorAll(".jsCarouselNews");

    this.hideContent = () => {
      if (typeof this._swiper !== 'undefined' && window.innerWidth >= 768) {
        let activeSlide = i.querySelector(".swiper-slide-active")
        activeSlide.classList.remove("carousel-news__slide--swiped")
      }
    };

    this.showContent = () => {
      if (typeof this._swiper !== 'undefined' && window.innerWidth >= 768) {
        let prevSlide = i.querySelector(".swiper-slide-prev")
        prevSlide.classList.add("carousel-news__slide--swiped")
      }
    };

    this.swipeSlides = () => {
      let slides = this._swiper.slides

      for (let i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains("swiper-slide-prev")) {
          slides[i].classList.add("carousel-news__slide--swiped")
        }
      }
    }

    this._swiper = new Swiper(this.carousel,{
      speed: 700,
      slidesPerView: 1.5,
      initialSlide: 1,
      centeredSlides: true,
      spaceBetween: 30,
      navigation: {
        nextEl: ".jsCarouselNewsNext",
        prevEl: ".jsCarouselNewsPrev",
        disabledClass: "carousel-news__arrow--hidden"
      },
      on: {
        slideNextTransitionStart: this.showContent,
        slidePrevTransitionStart: this.hideContent
      },
      breakpoints: {
        767: {
          slidesPerView: 1,
          spaceBetween: 0
        }
      }
    });

    if (window.innerWidth >= 768) {
      this.swipeSlides()
    }

    window.addEventListener("resize", () => {
      if (window.innerWidth >= 768) {
        this.swipeSlides()
      } else {
        let slides = this._swiper.slides

        for (let i = 0; i < slides.length; i++) {
          if (slides[i].classList.contains("swiper-slide-prev")) {
            slides[i].classList.remove("carousel-news__slide--swiped")
          }
        }
      }
    })
  }

  init() {
    for (let i = 0; i < this.carouselWrapper.length; i++) {
      const el = this.carouselWrapper[i];

      this.setCarousel(el);
    }
  }
}
